export class TipoMovimiento {
    constructor(
        public readonly Id: number,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Signo: number | null,
        public readonly TipoMovimientoEnum: number | null,
        public readonly TipoMovimiento: string | null,
        public readonly EsRecurrente: boolean,
        public readonly PeriodicidadRecurrencia: number | null,
        public readonly EsDefaultGasto: boolean | null,
        public readonly EsDefaultPedido: boolean | null,
        public readonly EsDefaultContrato: boolean | null,
        public  Activo: boolean
    ) { }
}

export class SearchTipoMovimientoRequest {
    constructor(
        public readonly PageSize: number | null,
        public readonly PageNumber: number | null,
        public readonly OrderAscending: boolean | null,
        public readonly OrderFieldName: string | null,
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Signo: number | null,
        public readonly VerSoloRecurrentes: boolean | null,
        public readonly VerSoloActivos: boolean | null
    ) { }
}

export class SaveTipoMovimientoDto {
    constructor(
        public readonly Codigo: string | null,
        public readonly Nombre: string | null,
        public readonly Signo: number | null,
        public readonly TipoMovimientoEnum: number | null,
        public readonly EsRecurrente: boolean | null,
        public readonly PeriodicidadRecurrencia: number | null,
        public readonly EsDefaultGasto: boolean | null,
        public readonly EsDefaultPedido: boolean | null,
        public readonly EsDefaultContrato: boolean | null,
        public readonly Activo: boolean
    ) { }
}

export class SearchTipoMovimientoResponse {
    constructor(
        public readonly count: number,
        public readonly result: TipoMovimiento[]
    ) { }
}

export class TipoMovimientoEnum {
    constructor(
      public readonly Id: number,
      public readonly Nombre: string
    ) {}
  }
